import React from 'react';

const Edit = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" {...props}>
    <path
      fillRule="evenodd"
      d="M18.189 2.133l2.126 2.126a2 2 0 0 1-.024 2.852L8 19H3v-5L15.39 2.104a2 2 0 0 1 2.799.029zM16.529 3.3L4.506 15.321l2.397 2.397 12.02-12.021L16.529 3.3zm-1.415 1.414l2.396 2.397-1.414 1.414L13.7 6.13l1.414-1.415z"
    />
  </svg>
);

export default Edit;
